import React from "react";

import * as S from "./styled";

const AdminFooter = () => (
  <S.Wrapper>
    <S.FooterSection>
      <S.FooterItem>
        <S.FooterLink href="/nyc/admin/source_groups">
          Source Groups
        </S.FooterLink>
      </S.FooterItem>
      <S.FooterItem>
        <S.FooterLink
          href="https://appext20.dos.ny.gov/nydos/selSearchType.do#nbb"
          target="_blank"
        >
          E-Access
        </S.FooterLink>
      </S.FooterItem>
      <S.FooterItem>
        <S.FooterLink href="/nyc/admin/users">User search</S.FooterLink>
      </S.FooterItem>
      <S.FooterItem>
        <S.FooterLink href="/nyc/admin/rentals">Rental search</S.FooterLink>
      </S.FooterItem>
      <S.FooterItem>
        <S.FooterLink href="/nyc/admin/sales">Sale search</S.FooterLink>
      </S.FooterItem>
      <S.FooterItem>
        <S.FooterLink
          href="https://a810-bisweb.nyc.gov/bisweb/bispi00.jsp"
          target="_blank"
        >
          NYC DOB
        </S.FooterLink>
      </S.FooterItem>
      <S.FooterItem>
        <S.FooterLink href="/nyc/admin/approval_listings?type=rental">
          LV approval (rentals)
        </S.FooterLink>
      </S.FooterItem>
      <S.FooterItem>
        <S.FooterLink href="/nyc/admin/approval_listings?type=sale">
          LV approval (sales)
        </S.FooterLink>
      </S.FooterItem>
    </S.FooterSection>
    <S.FooterSection>
      <S.FooterItem>
        <S.FooterLink
          href="/submit_your_listings?prd=submit_your_listing&lct=footer"
          target="_blank"
        >
          Submit your listings
        </S.FooterLink>
      </S.FooterItem>
      <S.FooterItem>
        <S.FooterLink href="/advertising" target="_blank">
          Advertise with us
        </S.FooterLink>
      </S.FooterItem>
      <S.FooterItem>
        <S.FooterLink
          href="https://www.zillow.com/corp/Privacy.htm"
          target="_blank"
        >
          Privacy policy
        </S.FooterLink>
      </S.FooterItem>
      <S.FooterItem>
        <S.FooterLink
          href="https://www.zillow.com/corp/Terms.htm"
          target="_blank"
        >
          Terms
        </S.FooterLink>
      </S.FooterItem>
      <S.FooterItem>
        <S.RedFooterLink href="https://www.zillow.com/careers/" target="_blank">
          We&apos;re hiring!
        </S.RedFooterLink>
      </S.FooterItem>
    </S.FooterSection>
    <S.FooterSection>
      <S.FooterItem>
        Zillow Inc. Sites &copy; 2006-{new Date().getFullYear()} Zillow
      </S.FooterItem>
      <S.FooterItem>Made In NYC</S.FooterItem>
      <S.FooterItem>Powered by Bikes, Coffee, and Doughnuts.</S.FooterItem>
    </S.FooterSection>
  </S.Wrapper>
);

export default AdminFooter;
